import { useQuery } from '@tanstack/react-query';

import AgreementsServiceClientImpl from 'src/api/agreementsService/client';
import { Themes } from 'src/shared/enum/Themes';

import { queryRetry } from '../query-retry';
import { Building } from '../../shared/types/building';
import { DevelopmentSlug } from '../../shared/enum/DevelopmentSlug';

export const useBookingTermsPdfData = (building: Building) => {
    const isHouseOfSocial = building.development_slug === DevelopmentSlug.HOUSE_OF_SOCIAL;
    const brand = isHouseOfSocial ? Themes.HOUSE_OF_SOCIAL : Themes.VITA_STUDENT;

    return useQuery({
        queryKey: ['booking-terms-pdf', brand],
        queryFn: async () => {
            const data = await new AgreementsServiceClientImpl().getBookingTermsPdf(brand);
            if (!data) throw new Error('No booking terms PDF data received');

            return `data:application/pdf;base64,${data}`;
        },
        retry: queryRetry,
    });
};
